import { useMemo } from "react";
import { SIZES } from "~/components/blocks/vod/top/const";
import { useTopDisplayItemCount } from "~/components/blocks/vod/top/hooks/use-top-display-item-count";
import { runningInBrowser } from "~/const/browser";

const HOME_VIDEO_HEADER_HEIGHT = 324;
const SUB_VIDEO_HEADER_HEIGHT = 164;
const ITEM_HEIGHT = 300;
const EXTRA_ITEMS = 2;

type Arg = { isVideoSubPage: boolean };
export const useSkeletonItems = ({ isVideoSubPage }: Arg) => {
  const windowHeight = runningInBrowser ? window.innerHeight : 0;

  const extraHeight = useMemo(
    () => windowHeight - (!isVideoSubPage ? HOME_VIDEO_HEADER_HEIGHT : SUB_VIDEO_HEADER_HEIGHT),
    [windowHeight, isVideoSubPage]
  );
  const maxColumnCount = useMemo(() => Math.floor(extraHeight / ITEM_HEIGHT) + EXTRA_ITEMS, [extraHeight]);

  const { displayItemCount } = useTopDisplayItemCount({ ...SIZES.RECOMMEND, heightRatio: 0 });

  const items = useMemo(() => {
    return [...Array(30)].map((_, idx) => {
      return {
        isFirstItem: idx === 0,
        isLastItem: 100 - 1 === idx,
        alt: `サンプル画像-${idx}`,
        borderRadius: "8px",
        aspectRatio: "7/5",
        src: "",
      };
    });
  }, []);

  return {
    maxColumnCount,
    displayItemCount,
    items,
  };
};
